import { render } from "./sunday.vue?vue&type=template&id=1ec31932&scoped=true"
import script from "./sunday.vue?vue&type=script&lang=js"
export * from "./sunday.vue?vue&type=script&lang=js"

import "./sunday.vue?vue&type=style&index=0&id=1ec31932&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ec31932"]])

export default __exports__